<template>
	<div class="popup-agreement-unaccepted-area">
		<section>
			<textarea-autosize placeholder="미동의 사유를 자유롭게 작성하시기 바랍니다" v-model="nonReason" :readonly="isReadOnly"></textarea-autosize>
		</section>
	</div>
</template>
<script>
import CONST from '@/constants';
import eventBus from '@/plugins/event-bus';

export default {
	title: '협약서 미동의 사유',
	name: 'PopupUnaccept',
	props: ['modalPram', 'openModalName'],
	data: function() {
		return {
			nonReason: '',
			loginMember: null,
		};
	},
	created() {},
	mounted() {
		let dt = this.$device.loadLocalData('LOGIN_USER');
		if (dt) this.loginMember = JSON.parse(dt);
		this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'BIZ');

		if (this.modalPram.reportType === CONST.REPORT_TYPE.AGREE_REPORT) {
			if (this.modalPram.nonAgreeReason !== '') this.nonReason = this.modalPram.nonAgreeReason;
		}
		if (this.modalPram.reportType === CONST.REPORT_TYPE.VISIT_REPORT) {
			if (this.modalPram.nonVisitReason !== '') this.nonReason = this.modalPram.nonVisitReason;
		}

		eventBus.$on(
			CONST.EVENTS.SAVE_MODAL,
			function(v, param) {
				if (param != null) {
					this.doSave(param);
					return false;
				}
			}.bind(this),
		);
	},
	beforeDestroy() {
		eventBus.$off(CONST.EVENTS.SAVE_MODAL);
	},
	computed: {
		isReadOnly: function() {
			return this.openModalName === 'agreeNoticeModal' || this.openModalName === 'visitNoticeModal';
		},
	},
	methods: {
		doSave: function(param) {
			if (this.nonReason === '') {
				alert('사유를 입력해 주세요');
				return false;
			}

			let formData = new FormData();
			formData.append('matchSeqNo', param.matchSeqNo);
			formData.append('seqNo', this.loginMember.seqNo);
			formData.append('agreeTarget', this.loginMember.budsUserType === CONST.USER_TYPE.COMPANY ? CONST.USER_TYPE.MARKETER : CONST.USER_TYPE.COMPANY);
			formData.append('nonReason', this.nonReason);
			formData.append('mtSubmitState', 'WRITING');
			formData.append('companySubmitState', 'WRITING');
			formData.append('visitReportState', 'WRITING');
			//기업방문보고서 미동의 사유
			if (param.reportType === CONST.REPORT_TYPE.VISIT_REPORT) {
				this.$apiClient
					.getInstance()
					.post(this.$apiClient.getApiServer() + '/api/business/updateVisitReportNonReason.do', formData)
					.then(res => {
						if (res.data.resultCode === 0) {
							window.alert('저장되었습니다.');
							window.location.reload();
						} else {
							window.alert(res.data.resultMsg);
						}
					})
					.catch(e => console.error(e));
			}
			//협약서 미동의 사유
			if (param.reportType === CONST.REPORT_TYPE.AGREE_REPORT) {
				this.$apiClient
					.getInstance()
					.post(this.$apiClient.getApiServer() + '/api/business/updateAgreementNonReason.do', formData)
					.then(res => {
						if (res.data.resultCode === 0) {
							window.alert('저장되었습니다.');
							param.nonAgreeReason = this.nonReason;
							param.mtSubmitState = 'WRITING';
							param.companySubmitState = 'WRITING';
							if (this.loginMember.budsUserType !== CONST.USER_TYPE.COMPANY) {
								eventBus.$emit(CONST.EVENTS.CONTRACT_UNACCEPT);
								eventBus.$emit(CONST.EVENTS.OPEN_MODAL, 'modalAgree', '협약관리', param);
							} else {
								window.location.reload();
							}
						} else {
							window.alert(res.data.resultMsg);
						}
					})
					.catch(e => console.error(e));
			}
		},
	},
};
</script>

<style scoped></style>
